<div style="width: 0">
  <igx-dialog #mensajeIntercambioDialog [closeOnOutsideSelect]="false" [closeOnEscape]="true" (closed)="close()">
    <div class="header neo-dialog-shell-header">
      <div class="neo-dialog-header">
        <div class="neo-dialog-header__leading">
          <div class="neo-dialog-header__icon">
            <igx-icon>send</igx-icon>
          </div>
          <div class="neo-dialog-header__title">{{ gTituloSistema() }}</div>
        </div>
      </div>
    </div>
    <div class="layout-box__el body" igxFlex style="width: 670px;">
      <div class="layout-box" igxLayout>
        <div igxFlex>
          <div igxFlex innerHTML="{{ alertMensaje | translate }}" class="tituloNotificaciones" style="padding-top: 5px"></div>
          <div igxFlex style="padding-top: 10px">
            <igx-checkbox #chkDescargar
                          [disabled]="!siHayDatosRespaldar">{{ 'MENSAJES.GRALS.DESCARGAR_ZIP' | translate }}
            </igx-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="footer neo-dialog-footer">
      <div id="navBarFooter" class="neo-dialog-footer__actions">
        @if (!formaQuestion) {
          <button igxButton="contained" (buttonClick)="cerrarVentana(chkDescargar)">
            <igx-icon>check</igx-icon>
            <span>OK</span>
          </button>
        }
        @if (formaQuestion) {
          <button igxButton="contained" (click)="cerrarVentana(chkDescargar)">
            <igx-icon>check</igx-icon>
            <span>{{ 'BOTONES.ACEPTAR' | translate }}</span>
          </button>
          <button igxButton="flat" (click)="close()">
            <igx-icon>close</igx-icon>
            <span>{{ 'BOTONES.CANCELAR' | translate }}</span>
          </button>
        }
      </div>
    </div>
  </igx-dialog>
</div>
